let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("16C5P")).then(() => parcelRequire('iDGEe'));